import '.di{font-size:1.125rem;}.ssr-plugin'
import '.f7{line-height:1.75rem;}.ssr-plugin'
import '.i4{text-decoration:none;}.ssr-plugin'
import '.do{color:var(--primary-red);}.ssr-plugin'
import { pages } from '@app/util/links'
import { useTranslations } from '@i18n/useLanguage'
import { styled } from 'inlines'

export const TermsAndConditions = () => {
  const translations = useTranslations().app.auth
  return (
    <p className="di f7"
    >
      {translations.privacySubtitle}{' '}
      <a className="i4 do"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.privacyStatementLink}
      </a>{' '}
      {translations.privacySubtitleAnd}{' '}
      <a className="i4 do"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.termsAndConditionsLink}
      </a>
    </p>
  )
}
